



































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import * as moment from 'moment';
import numeral from 'numeral';
import {NumberHelper} from '@/utils/number.helper';

import {IData, IGoalVsRegistration} from '@/modules/business-plan/modules/report/types';
import {GoalVsRegistrationType} from '@/modules/business-plan/modules/models/enums/goalVsRegistrationType';
import TableTrTtlMonthlyGoalRegistrationComponent
  from '@/modules/business-plan/modules/report/table-tr-ttl-monthly-goal-registration.page.vue';

@Component({
  name: 'TableMonthlyGoalRegistration',
  components: { TableTrTtlMonthlyGoalRegistrationComponent }
})
export default class TableMonthlyGoalRegistration extends Vue {
  public GoalVsRegistrationType = GoalVsRegistrationType;
  public NumberHelper = NumberHelper;
  public numeral = numeral;
  public months = new Array(12).fill(0).map((_, index) =>  1 + index);

  @Prop({required: true})
  public yearReference: number;

  @Prop({required: true})
  public endMonthRegistration: number;

  @Prop({required: true})
  public data: IData;

  @Prop({required: true})
  public storeValue: IGoalVsRegistration;

  @Prop({required: true})
  public format: string;

  public getFormatLabel(getReverse: boolean = false): string {
      if (!this.format)
          return '';

     const labels = {
         Channel: 'CANAL',
         Family: 'FAMÍLIA'
     };

     if (getReverse) {
         return this.format.toUpperCase() == labels.Channel ? labels.Family : labels.Channel;
     }

     return this.format.toUpperCase();
  }

  public getMonthName(month): string {
    return ((moment.localeData() as any)._monthsShort[month - 1]).toUpperCase();
  }
}
